(function($){
	$(".device-selector ul.device-menu-main li").each(function(){
		$(this).click(function(){
			$(this).children("ul").show();
		});
		$(this).children('ul').children('li.back').each(function(){
			$(this).click(function(){
				var backElement = $(this).parents().eq(0);
				setTimeout(function(){
					$(backElement).hide();
				}, 200);
			});
		});
	});
	$("li.second-level-devices").each(function(){
		$(this).click(function(){
			$("li.second-level-devices").removeClass("second-level-devices-active");
			$(this).addClass("second-level-devices-active");
		});
	});
    
})(jQueryTheme);
